import pollGroupSiteCreation from './pollGroupSiteCreation';
import { getErrorFromObject } from '../logging/genericInformationLogging';
import {
    getGroupDetails,
    getGroupResourceUrl,
    getGroupSiteStatusStore,
    setGroupSiteStatus,
    updateGroupSiteAndDocumentUrl,
} from 'owa-groups-shared-store';
import { GroupSiteStatus } from 'owa-groups-sharepoint-commands';
import { PerformanceDatapoint, DatapointStatus } from 'owa-analytics';
import { parse as parseUrl } from 'url';

export function ensureGroupSiteCreation(groupSmtpAddress: string): Promise<void> {
    const datapoint = new PerformanceDatapoint('GroupFilesHubEnsureGroupSiteCreationDP');
    groupSmtpAddress = groupSmtpAddress.toLowerCase();
    const groupSiteStatus = getGroupSiteStatusStore().groupSiteStatus.get(groupSmtpAddress);

    if (groupSiteStatus == GroupSiteStatus.NotFound) {
        const error = new Error('Group details or site information is null or empty.');
        datapoint.endWithError(DatapointStatus.ServerError, error);
        return Promise.reject(error);
    }

    if (groupSiteStatus == GroupSiteStatus.Ready) {
        datapoint.addCustomProperty('GroupSiteUrlIsProvisioned', true);
        datapoint.end();
        return Promise.reject(new Error('GroupSiteIsAlreadyProvisioned'));
    }

    if (groupSiteStatus == GroupSiteStatus.Error) {
        // GetGroupDetails would always reset group site status before we start polling which means group site status should never be Error here.
        const error = new Error(
            'getGroupDetails resets the group site status has not been completed.'
        );
        datapoint.endWithError(DatapointStatus.ClientError, error);
        return Promise.reject(error);
    }

    const groupDetails = getGroupDetails(groupSmtpAddress);
    const groupSiteUrl = getGroupResourceUrl(groupDetails, 'Site');
    datapoint.addCustomProperty('GroupSiteUrlIsProvisioned', false);
    datapoint.addCheckmark('PollGroupSiteStart');
    const parsedGroupSiteUrl = parseUrl(groupSiteUrl, false, true);
    const groupSiteRootUrl = `${parsedGroupSiteUrl.protocol}//${parsedGroupSiteUrl.host}`;
    return pollGroupSiteCreation(groupSiteRootUrl, groupDetails.ExternalDirectoryObjectId)
        .then(response => {
            datapoint.addCheckmark('PollGroupSiteDone');
            updateGroupSiteAndDocumentUrl(
                groupSmtpAddress,
                response.SiteStatus,
                response.SiteUrl,
                response.DocumentsUrl
            );
            setGroupSiteStatus(groupSmtpAddress, response.SiteStatus);
            datapoint.end();
        })
        .catch(error => {
            setGroupSiteStatus(groupSmtpAddress, GroupSiteStatus.Error);
            datapoint.endWithError(DatapointStatus.ClientError, getErrorFromObject(error));
            throw error;
        });
}
